import type { FC, SVGProps } from 'react'
import { theme } from '@theme'

type IconProps = SVGProps<SVGSVGElement> & {
  pathProps?: SVGProps<SVGPathElement>
  rectProps?: SVGProps<SVGRectElement>
}

export const ErrorIcon = ({ pathProps, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    {...props}
  >
    <path
      d="M9.49913 6.33329V9.49996M9.49913 12.6666H9.50705M8.14538 2.26413L1.43996 13.4583C1.30171 13.6977 1.22856 13.9692 1.22779 14.2456C1.22702 14.5221 1.29865 14.7939 1.43555 15.0341C1.57246 15.2743 1.76987 15.4745 2.00815 15.6147C2.24643 15.7549 2.51726 15.8303 2.79371 15.8333H16.2045C16.481 15.8303 16.7518 15.7549 16.9901 15.6147C17.2284 15.4745 17.4258 15.2743 17.5627 15.0341C17.6996 14.7939 17.7712 14.5221 17.7705 14.2456C17.7697 13.9692 17.6965 13.6977 17.5583 13.4583L10.8529 2.26413C10.7118 2.03146 10.513 1.83909 10.2759 1.70559C10.0388 1.57209 9.77125 1.50195 9.49913 1.50195C9.22701 1.50195 8.95948 1.57209 8.72235 1.70559C8.48523 1.83909 8.28651 2.03146 8.14538 2.26413Z"
      stroke={theme.colors.error}
      strokeWidth="1.78125"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathProps}
    />
  </svg>
)

export const SuccessIcon = ({ pathProps, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M18.3334 9.23355V10.0002C18.3324 11.7972 17.7505 13.5458 16.6745 14.9851C15.5986 16.4244 14.0862 17.4773 12.3629 17.9868C10.6396 18.4963 8.7978 18.4351 7.11214 17.8124C5.42648 17.1896 3.98729 16.0386 3.00922 14.5311C2.03114 13.0236 1.56657 11.2403 1.68481 9.44714C1.80305 7.65402 2.49775 5.94715 3.66531 4.58111C4.83288 3.21506 6.41074 2.26303 8.16357 1.867C9.91641 1.47097 11.7503 1.65216 13.3918 2.38355M18.3334 3.33355L10.0001 11.6752L7.50009 9.17521"
      stroke={theme.colors.success}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathProps}
    />
  </svg>
)

export const CheckIcon: FC<IconProps> = ({ pathProps, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M13.3334 4L6.00008 11.3333L2.66675 8"
      stroke="#16A34A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathProps}
    />
  </svg>
)

export const ArrowDownIcon: FC<IconProps> = ({ pathProps, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    {...props}
  >
    <path
      d="M0.833496 0.833008L5.8335 5.83301L10.8335 0.833008"
      stroke="#475569"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathProps}
    />
  </svg>
)

export const LockIcon: FC<IconProps> = ({ pathProps, rectProps, ...props }) => (
  <svg
    className={'lock-icon'}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke={'#64748B'} {...rectProps} />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke={'#64748B'} {...pathProps} />
  </svg>
)

export const CardIcon = ({ pathProps, ...props }: IconProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.583374 5.83331H13.4167M1.75004 2.33331H12.25C12.8944 2.33331 13.4167 2.85565 13.4167 3.49998V10.5C13.4167 11.1443 12.8944 11.6666 12.25 11.6666H1.75004C1.10571 11.6666 0.583374 11.1443 0.583374 10.5V3.49998C0.583374 2.85565 1.10571 2.33331 1.75004 2.33331Z"
      stroke="#475569"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathProps}
    />
  </svg>
)
